"use strict";

let burger = document.querySelector("#burger");
let nav = document.querySelector("#bar");
let GIF = document.querySelector("#gif");
let arrow = document.querySelector("#arrow");
let body = document.querySelector("#body");

/*BURGER MENU*/

burger.addEventListener("click", (e) =>{
    burger.classList.toggle("change");
    nav.classList.toggle("hidden");
})

/*REMOVE ANCHOR*/

if(body.classList.contains("index")){
    arrow.addEventListener("click", (e) => {
        setTimeout(() => {
            removeHash();
        }, 5);
    });
}

function removeHash(){
  history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
}

/*NAV SCROLL*/

let prevScrollpos = window.pageYOffset;

window.onscroll = HiddenNav;

function HiddenNav() {
    let currentScrollPos = window.pageYOffset;
    let nav = document.querySelector(".header");
      if (prevScrollpos > currentScrollPos) {
        nav.classList.remove("header__scroll");
      } else {
        nav.classList.add("header__scroll");
      }
      prevScrollpos = currentScrollPos;
    }

/*DARKMODE*/

let currentTheme = localStorage.getItem("theme");
let buttondm = document.querySelector("#darkmode");
let logo = document.querySelector("#logo");
let theme = localStorage.getItem("theme");

buttondm.addEventListener("click", darkmode);

if(theme == "night"){
    night();
  }

function darkmode() {
    if (body.classList.contains("day")){
      night();
    } else if(body.classList.contains("night")) {
      day();
    }
  }

function day(){
    body.classList.toggle("night");
    body.classList.toggle("day");
    logo.srcset = "assets/images/logo.svg";
    localStorage.setItem("theme", "day");
}

function night(){
    body.classList.toggle("night");
    body.classList.toggle("day");
    logo.srcset = "assets/images/logonight.svg";
    localStorage.setItem("theme", "night");
}
